import {Controller} from "@hotwired/stimulus"

const TOAST_TYPES = {notice: "success", alert: "alert", warning: "warning"}

// toastr 2.1.0 inserts the message as HTML, so the text is escaped first.
function escapeHtml(text) {
  const element = document.createElement("div")
  element.textContent = text
  return element.innerHTML
}

// Shows the flash messages the server rendered into this element as toasts.
export default class extends Controller {
  static values = {notice: String, alert: String, warning: String}

  connect() {
    if (typeof window.toast_message !== "function") return

    Object.entries(TOAST_TYPES).forEach(([key, type]) => {
      const message = this[`${key}Value`]
      if (!message) return

      window.toast_message({message_type: type, message_content: escapeHtml(message), closeButton: "true"})
    })
  }
}
